import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { useContentObjectContext } from "../contexts/ContentObjectContext";
// import { globalConfig } from "../../config";

const ManageContent = () => {
  const { id } = useParams();
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const {token,userMetadata}=useAuth()
  const [contentFileTypes, setContentFileTypes] = useState([]);
  const [contentInputSourceTypes, setContentInputSourceTypes] = useState([]);
  const { currentContentObject } = useContentObjectContext();
  console.log(currentContentObject);
  const [state, setState] = useState({
    contentId: id,
    contentImageFile: "",
    contentImageFileType: 0,
    contentTitle: "",
    contentName: "",
    inputSourceValueCode: 0,
    securityContextId: 0,
    createUser: 0,
    createDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
    contentCdata: "",
    contentBdata: "",
    deleteFlag: 0,
    contentTypes: "",
    proofingStatusCode: 0,
    proofingStatusMsg: "",
    partNumber: "",
    recordCount: 0,
    filesize: 0,
    uploadFileType: 0,
    platformEntryPoint: "",
    serviceEntryPoint: "",
    callbackEntryPoint: "",
    httpMethod: "",
    rate: 0,
    billingMethod: "",
    authKey: "",
    apiKey: "",
    apiSecret: "",
    version: "",
  });

  const [types, setTypes] = useState([]);
  const [annotations, setAnnotations] = useState([]);
  const [descriptors, setDescriptors] = useState([]);
  const [applications, setApplications] = useState([]);
  const [associations, setAssociations] = useState([]);
  const [transformers, setTransformers] = useState([]);
  const [facades, setFacades] = useState([]);
  const [indices, setIndices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [templates, setTemplates] = useState([]);

  useEffect(() => {}, []);
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  useEffect(() => {
    handleOnLoad();
    handleLoadAssignedToContentObject();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");
    const {
      contentId,
      contentName,
      contentTitle,
      contentImageFileType,
      inputSourceValueCode,
      contentImageFile,
    } = state;
    let patchedState = {
      contentId,
      contentName,
      contentTitle,
      contentImageFileType,
      inputSourceValueCode,
      contentImageFile,
    };
    var url = `${globalConfig.apiDatahubUrl}/contents/${state.contentId}`;
    console.log(JSON.stringify(patchedState));
    axios
      .patch(url, patchedState, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }

  const handleLoadAssignedToContentObject = () => {
    //getting all assigned  types
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-types?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const types = res.data;
        console.log("contentTypes");
        console.log(types);
        // setAssignedTo({...assignedTo,types:types});
        setTypes(types);
      });

    //getting all assigned annotations
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-annotations?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const annotations = res.data;
        console.log("content annotations");
        console.log(annotations);
        setAnnotations(annotations);
      });
    //getting all assigned descriptors
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-descriptors?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const descriptors = res.data;
        console.log("content descriptors");
        console.log(descriptors);
        setDescriptors(descriptors);
      });

    //getting all assigned associations
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-associations?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const associations = res.data;
        console.log("content associations");
        console.log(associations);
        setAssociations(associations);
      });

    //getting all assigned facades
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-facades?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const facades = res.data;
        console.log("content facades");
        console.log(facades);
        setFacades(facades);
      });

    //getting all assigned indices
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-indices?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const indices = res.data;
        console.log("content indices");
        console.log(indices);
        setIndices(indices);
      });

    //getting all assigned categories
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-categories?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const categories = res.data;
        console.log("content categories");
        console.log(categories);
        setIndices(categories);
      });

    //getting all assigned templates
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-templates?filter[where][or][0][contentId]=${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const templates = res.data;
        console.log("content templates");
        console.log(templates);
        setTemplates(templates);
      });
  };

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/contents/${state.contentId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_FILE_TYPE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentFileTypes = res.data;
        console.log(contentFileTypes);
        setContentFileTypes(contentFileTypes);
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_INPUT_SOURCE_TYPE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentInputSourceTypes = res.data;
        console.log(contentInputSourceTypes);
        setContentInputSourceTypes(contentInputSourceTypes);
      });
  };

  function onDelete() {
    let deleteID = state.contentId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/contents/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        navigate.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }

  return (
    <form>
      <div className="container-fluid">
        <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => navigate.goBack()}
        >
          Go Back
        </button>
        <h4>Manage Content</h4>
        <hr />
        <h4>Summary</h4>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Name">
            Name
          </label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="contentName"
            value={state.contentName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Title">
            Title
          </label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="contentTitle"
            value={state.contentTitle}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Input Source">
            Input Source
          </label>
          <select
            className="form-control input-big col-sm-8"
            id="inputSourceValueCode"
            value={state.inputSourceValueCode}
            onChange={handleChange}
          >
            {/* <option value="#{ombNeoServerForm.contentInputSourcesList}" /> */}
            <option value={0}>Select Input Source Type</option>
            {contentInputSourceTypes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content File Type">
            Content File Type
          </label>
          <select
            className="form-control input-big col-sm-8"
            id="contentImageFileType"
            value={state.contentImageFileType}
            onChange={handleChange}
          >
            <option value={0}>Select File Type</option>
            {contentFileTypes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content File">
            Content File
          </label>
          <input
            className="form-control input-big col-sm-8"
            id="contentImageFile"
            onChange={handleChange}
            value={state.contentImageFile}
          />
        </div>

        <h4>Content Properties</h4>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content CData">
            Content CData
          </label>
          <textarea
            readOnly={true}
            className="form-control input-big col-sm-8"
            id="content_cdata"
            value={state.contentCdata}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content BData">
            Content BData
          </label>
          <textarea
            readOnly={true}
            className="form-control input-big col-sm-8"
            id="contentBdata"
            value={state.contentBdata}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Assigned Types">
            Assign Types
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned types</option>
            {types.map((item, index) => (
              <option key={index}>{item.contentTypeName}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Assigned Annotations">
            Assigned Annotations
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Annotations</option>
            {annotations.map((item, index) => (
              <option key={index}>{item.annotationName}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Assigned Descriptors">
            Assigned Descriptors
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Descriptors</option>
            {descriptors.map((item, index) => (
              <option key={index}>{item.contentId}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Assigned Applications"
          >
            Assigned Applications
          </label>
          <textarea
            readOnly={true}
            className="form-control input-big col-sm-8"
            value=""
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Assigned Transformers"
          >
            Assigned Transformers
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Transformers</option>
            {transformers.map((item, index) => (
              <option key={index}>{item.contentId}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Assigned Associations"
          >
            Assigned Associations
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Associations</option>
            {associations.map((item, index) => (
              <option key={index}>{item.contentAssociationName}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Assigned Facades">
            Assigned Facades
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Facades</option>
            {facades.map((item, index) => (
              <option key={index}>{item.contentFacadeName}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Assigned Indexes">
            Assigned Indices
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Indices</option>
            {indices.map((item, index) => (
              <option key={index}>{item.contentIndexName}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Assigned Categories">
            Assigned Categories
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Categories</option>
            {categories.map((item, index) => (
              <option key={index}>{item.contentCategoryName}</option>
            ))}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Assigned Templates">
            Assigned Templates
          </label>
          <select className="form-control col-sm-8">
            <option>Click to view all assigned Templates</option>
            {templates.map((item, index) => (
              <option key={index}>{item.contentTemplateName}</option>
            ))}
          </select>
        </div>

        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Created By">
            Created By
          </label>
          <input
            className="form-control input-xlarge col-sm-1"
            readOnly={true}
            value={state.createUser}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="On">
            On
          </label>
          <input
            className="form-control input-xlarge col-sm-3"
            readOnly={true}
            type="datetime-local"
            value={state.createDate?.slice(0, 16)}
          ></input>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Last Updated By ">
            Last Update By
          </label>
          <input
            className="form-control input-xlarge col-sm-1"
            readOnly={true}
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="On">
            On
          </label>
          <input
            className="form-control input-xlarge col-sm-3"
            readOnly={true}
            type="datetime-local"
            value={state.lastUpdateDate.slice(0, 16)}
          ></input>
        </div>

        <hr />
        <dic columns="3">
          <button className="btn btn-success" value="Save" onClick={handleSave}>
            Save
          </button>
          &nbsp;
          <button
            className="btn btn-danger"
            value="Delete"
            type="button"
            onClick={onDelete}
          >
            Delete
          </button>
        </dic>
      </div>
    </form>
  );
};

export default ManageContent;
